import { render, staticRenderFns } from "./TableCartSidebar.vue?vue&type=template&id=94e46058"
import script from "./TableCartSidebar.vue?vue&type=script&lang=js"
export * from "./TableCartSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports